//The default for the hidden field on Gravity Forms is set to "CareMetx"

class GravityFormContactUs {
  constructor(el) {
    this.el = el;
    this.hiddenField = this.el.querySelector(
      "input[value=CareMetx][type=hidden]"
    ); //Hidden field must have default value set to "CareMetx in gravity forms"
    this.topicField = this.el.querySelector(".topic-field select"); //.topic-field must be added to the desired select field in the gravity form in the WP Admin
    this.topicOptions = this.el.querySelectorAll(".topic-field select option");
    this.noTypeArray = [
      "Individual Donations",
      "Corporate Donations",
      "Media Inquiries",
      "Partner with Us",
      "Share Your Story",
    ]; //array of items that should have no assigned type
    this.hasTypeArray = [
      "General Inquiry",
      "Claims",
      "Enrollment",
      "Portal Support",
      "Formulary/Medication Covered Inquiry",
      "New Disease Fund Request",
    ]; //array of items that should have assigned type

    // die if no topic field
    if (!this.topicField) return;

    //Check value
    this.initOnLoad(this.topicField.value);

    //On Change
    this.topicField.addEventListener("change", (event) => {
      //We are only checking onChange because the
      const selectedOption = event.target.value;
      const noType = this.noTypeArray.includes(selectedOption);
      const hasType = this.hasTypeArray.includes(selectedOption);

      if (noType) {
        this.hiddenField.value = "None";
      } else if (hasType) {
        this.hiddenField.value = "CareMetx";
      }
    });
  }

  initOnLoad(topicFieldValue) {
    const noType = this.noTypeArray.includes(topicFieldValue);
    const hasType = this.hasTypeArray.includes(topicFieldValue);

    if (noType) {
      this.hiddenField.value = "None";
    } else if (hasType) {
      this.hiddenField.value = "CareMetx";
    }
  }
}

const init = () => {
  let contactFormClass = document.querySelector(".general-contact-form"); // This class must be added to the gravity form in the WP Admin

  if (contactFormClass) {
    new GravityFormContactUs(contactFormClass);
  }
};

// Init on initial page load
init();
